import React from 'react';
import Map from './Map';

const Footer = () => {
  return (
    <footer id="footer" style={{ color: 'white' }}>
      <div className="container-fluid bg-dark footer mt-5 pt-5 wow fadeIn" data-wow-delay="0.1s">
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-lg-6 col-md-6">
              <h1 className="fw-bold mb-4 lh-1">
                <span className="text-orange d-block">Organique</span>
                <span className="text-orange d-block">Juice Bar</span>
              </h1>
              <p>Fresh, wholesome ingredients that nourish gently. At Organique Juice Bar, healthy eating isn't a rule — it's a joy you can taste in every bite.</p>
              <div className="d-flex pt-2">
                {/* <a className="btn btn-square btn-outline-light rounded-circle me-1" href="#"><i className="fab fa-twitter"></i></a>
                <a className="btn btn-square btn-outline-light rounded-circle me-1" href="#"><i className="fab fa-facebook-f"></i></a>
                <a className="btn btn-square btn-outline-light rounded-circle me-1" href="#"><i className="fab fa-youtube"></i></a>
                <a className="btn btn-square btn-outline-light rounded-circle me-0" href="#"><i className="fab fa-linkedin-in"></i></a> */}
                <a className="btn btn-square btn-outline-light rounded-circle me-0" href="https://www.instagram.com/organiquejuicebar.oakville"><i className="fab fa-instagram"></i></a>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <h4 className="text-light mb-4">Address</h4>
              <p><i className="fa fa-map-marker-alt me-3"></i>579 Kerr St Unit 4, Ontario, CA</p>
              <p><i className="fa fa-phone-alt me-3"></i>905 338 6899</p>
              <p><i className="fa fa-envelope me-3"></i>info@organiquejuicebar.ca</p>
            </div>
            {/* <div className="col-lg-3 col-md-6">
              <h4 className="text-light mb-4">Quick Links</h4>
              <a className="btn btn-link" href="#">About Us</a>
              <a className="btn btn-link" href="#">Contact Us</a>
              <a className="btn btn-link" href="#">Our Services</a>
              <a className="btn btn-link" href="#">Terms & Condition</a>
              <a className="btn btn-link" href="#">Support</a>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="text-light mb-4">Newsletter</h4>
              <p>Subscribe to our newsletter for fresh recipes, wellness tips, and special offers on organic juices and smoothies.</p>
              <div className="position-relative mx-auto" style={{maxWidth: '400px'}}>
                <input className="form-control bg-transparent w-100 py-3 ps-4 pe-5" type="text" placeholder="Your email" />
                <button type="button" className="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2">SignUp</button>
              </div>
            </div> */}
          </div>
        </div>
        <div className="container-fluid copyright">
          <div className="container">
            <div className="row">
              <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                &copy; <a href="#">Organique Juice Bar</a>, All Right Reserved.
              </div>
              <div className="col-md-6 text-center text-md-end">
              </div>
            </div>
          </div>
        </div>
      </div>

      <Map />

      {/* Back to Top */}
      <a href="#" className="btn btn-lg btn-primary btn-lg-square rounded-circle back-to-top"><i className="bi bi-arrow-up"></i></a>
    </footer>
  );
};

export default Footer;